import { Select } from "components/ui/select/Select"
import type { TErefWithFurniture } from "types/elevationReferences.type"
import type { TQuotationComponentOption } from "types/quotations.type"
import type { TErefConfigurationSavePayload, TErefConfigOptimisticPatch } from "../../useErefConfigurationSave"
import style from "./CountertopSeries.module.scss"

const { countertopSeries, label } = style

type Props = {
	eref: TErefWithFurniture
	save: (
		payload: TErefConfigurationSavePayload,
		optimistic?: TErefConfigOptimisticPatch,
		countertopSeriesName?: string | null,
	) => void
	isPending: boolean
	countertopOptions: TQuotationComponentOption[]
}

export const CountertopSeries = ({ eref, save, isPending, countertopOptions }: Props) => {
	const config = eref.estimation_config

	const onChange = (v: unknown) => {
		const id = (v as number | undefined) ?? null
		// REQ-405: hands the picked option's name (or null when clearing) to `save`, which uses it to
		// keep every already-loaded INHERITING countertop furniture connected to this eref in sync —
		// see useErefConfigurationSave's `countertopSeriesName` param for why this can't be derived
		// from the PATCH response alone.
		const name = id != null ? (countertopOptions.find((o) => o.id === id)?.name ?? null) : null
		save({ countertop_series_and_colors_id: id }, undefined, name)
	}

	return (
		<div className={countertopSeries}>
			<span className={label}>Countertops series</span>
			<Select
				variant="outlined"
				options={countertopOptions.map((o) => ({ label: o.name, value: o.id }))}
				value={config?.countertop_series_and_colors_id ?? null}
				onChange={onChange}
				disabled={isPending}
				allowClear={config?.countertop_series_and_colors_id == null}
				placeholder="Select countertop series"
				renderInPlace
			/>
		</div>
	)
}
